import { X } from "lucide-react";
import { Link, useLocation } from "react-router";
import { findRouteByPath } from "@/shared/configs/routeRegistry.config";
import { useFavorites } from "@/shared/contexts/FavoritesContext";
import { cn } from "@/shared/lib/utils";
import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from "@/shared/ui/Sidebar";

const FavoritesSection = () => {
  const { favorites, removeFavorite } = useFavorites();
  const { state } = useSidebar();
  const collapsed = state === "collapsed";
  const location = useLocation();

  const resolvedFavorites = favorites
    .map((path) => {
      const route = findRouteByPath(path);
      if (!route?.navigation) return null;
      return {
        path,
        label: route.navigation.label,
        icon: route.navigation.icon,
      };
    })
    .filter(Boolean) as Array<{ path: string, label: string, icon: React.ComponentType }>;

  if (resolvedFavorites.length === 0) return null;

  const isActiveRoute = (url: string) => {
    if (url === "/") return location.pathname === url;
    return location.pathname.startsWith(url)
      && (location.pathname === url || location.pathname.charAt(url.length) === "/");
  };

  return (
    <SidebarGroup>
      {!collapsed && <SidebarGroupLabel>Favoris</SidebarGroupLabel>}
      <SidebarMenu>
        {resolvedFavorites.map(({ path, label, icon: Icon }) => {
          const isActive = isActiveRoute(path);
          return (
            <SidebarMenuItem key={path}>
              <div className="group/fav relative flex items-center">
                <SidebarMenuButton
                  asChild
                  tooltip={collapsed ? label : undefined}
                  className="flex-1"
                >
                  <Link
                    to={path}
                    className={cn(
                      isActive
                        ? "bg-primary text-white font-medium hover:!bg-primary hover:!text-white transition-colors"
                        : "",
                    )}
                  >
                    <Icon />
                    {!collapsed && <span>{label}</span>}
                  </Link>
                </SidebarMenuButton>
                {!collapsed && (
                  <button
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      removeFavorite(path);
                    }}
                    className="absolute right-1 opacity-0 group-hover/fav:opacity-100 transition-opacity p-1 rounded-sm hover:bg-muted"
                    aria-label={`Retirer ${label} des favoris`}
                  >
                    <X className="size-3 text-muted-foreground" />
                  </button>
                )}
              </div>
            </SidebarMenuItem>
          );
        })}
      </SidebarMenu>
    </SidebarGroup>
  );
};

export default FavoritesSection;
